<template>
    <div>
        <input
                size="70"
                type="text"
                id="labelId"
                name="labelId"
                :value="computedValue"
                @change="onChange($event)"
        >&nbsp;
        <p>Introducir ids de etiquetas separadas por comas.</p>
        <div v-if="showSpinner" class="spinner-border"></div>
        <p v-if="labelText">
            Etiquetas seleccionadas: <b v-html="labelText"></b>
        </p>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'label-input',
        props: {
            selectedValue : {
                type: String
            }
        },
        data () {
            return {
                value : null,
                labelText : null,
                showSpinner : false,
            };
        },
        computed: {
            computedValue: function () {
                return this.value !== null ? this.value : this.selectedValue;
            }
        },
        methods: {
            onChange: function(event) {
                this.value = event.target.value;
                this.$emit('update', this.value);
                this.displayLabels (event.target.value);
            },
            displayLabels (labelIds) {
                this.showSpinner = true;
                let ids = labelIds.replace(" ", "").split(",");
                let labelParams = [];
                ids.forEach(function(id) {
                    labelParams.push("ids[]=" + id);
                })
                axios
                    .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_web_json/Label/text?' + labelParams.join("&"))
                    .then(response => {
                        if (response.data && response.data.data[0]) {
                            this.labelText = response.data.data[0];
                        } else {
                            this.labelText = this.invalidlabelMessage(labelIds);
                        }
                    }).catch(error => {
                        this.labelText = this.invalidlabelMessage(labelIds);
                        this.emitError(error);
                    }).finally (() => {
                        this.showSpinner = false;
                    });
            },
            invalidlabelMessage(labelId) {
                return "La etiqueta " + labelId + " no existe!!";
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar la etiqueta.");
            }
        },
        watch: {
            selectedValue: function () {
                if (this.computedValue) {
                    this.displayLabels (this.computedValue);
                }
            }
        }
    }
</script>